import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Grid,
  Alert,
  Snackbar,
} from "@mui/material";
import api from "../config/axios";

function Settings() {
  const [settings, setSettings] = useState({
    auto_message_interval: "50",
    twitch_channel: "laboite_fred",
  });
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await api.get("/api/settings");
      setSettings(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des paramètres:", error);
      showSnackbar("Erreur lors de la récupération des paramètres", "error");
    }
  };

  const handleChange = (key, value) => {
    setSettings({
      ...settings,
      [key]: value,
    });
  };

  const handleSave = async (key) => {
    setLoading(true);
    try {
      await api.put(`/api/settings/${key}`, { value: settings[key] });
      showSnackbar("Paramètre mis à jour avec succès", "success");
    } catch (error) {
      console.error("Erreur lors de la mise à jour:", error);
      showSnackbar("Erreur lors de la mise à jour", "error");
    } finally {
      setLoading(false);
    }
  };

  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Configuration
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Messages automatiques
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
              Nombre de messages entre chaque envoi automatique
            </Typography>
            <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
              <TextField
                fullWidth
                type="number"
                label="Intervalle de messages"
                value={settings.auto_message_interval}
                onChange={(e) =>
                  handleChange("auto_message_interval", e.target.value)
                }
                helperText="Valeur par défaut : 50"
                inputProps={{ min: 1, max: 1000 }}
              />
              <Button
                variant="contained"
                onClick={() => handleSave("auto_message_interval")}
                disabled={loading}
                sx={{ mt: 1 }}
              >
                Enregistrer
              </Button>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Canal Twitch
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
              Nom du canal Twitch (lecture seule)
            </Typography>
            <TextField
              fullWidth
              label="Canal"
              value={settings.twitch_channel}
              disabled
              helperText="Ce paramètre est en lecture seule"
            />
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 3 }}>
            <Alert severity="info">
              <Typography variant="body2">
                <strong>Important :</strong> Les changements d'intervalle de
                messages prendront effet lors du prochain rechargement du cache
                du bot (toutes les 5 minutes maximum).
              </Typography>
            </Alert>
          </Paper>
        </Grid>
      </Grid>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default Settings;
